import store from '@/store';
import { LocalStorageActionTypes, LocalStorageGetterTypes } from '@/store/modules/localStorage';

type DeviceIdMap = Record<string, string>; // userId(文字列化) → deviceId

function loadDeviceIdMap(): DeviceIdMap {
  const parsed = store.getters[LocalStorageGetterTypes.JOHAISETSU_DEVICE_IDS];
  // localStorage側で永続化前の検証がないため、プレーンオブジェクトかつ値が文字列であることをここで検証する
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return {};
  }
  const map: DeviceIdMap = {};
  for (const [key, value] of Object.entries(parsed)) {
    if (typeof value === 'string') {
      map[key] = value;
    }
  }
  return map;
}

export function getJohaisetsuDeviceId(userId: number): string | null {
  return loadDeviceIdMap()[String(userId)] ?? null;
}

export function saveJohaisetsuDeviceId(userId: number, deviceId: string): void {
  const map = { ...loadDeviceIdMap(), [String(userId)]: deviceId };
  try {
    store.dispatch(LocalStorageActionTypes.SET, { key: LocalStorageGetterTypes.JOHAISETSU_DEVICE_IDS, val: map });
  } catch (e) {
    // 保存失敗(容量超過・プライベートモード等)時は次回も新端末扱いになるだけなので握りつぶす
  }
}
